import * as React from "react";
import { SlideMenu } from "@bizform/primereact/slidemenu";
import { SlideMenuProps } from "@bizform/primereact/components/slidemenu/SlideMenu";
import { MenuItem } from "@bizform/primereact/components/menuitem/MenuItem";
import { Static } from "@bizform/type/decorator/Static.decorator";
import {
    BaseStateModel,
    ComponentElement,
    ComponentElementDisplayMode,
    ComponentElementStatic
} from "@bizform/type/model/component_element/ComponentElement.model";
import {
    ComponentCategory,
    ComponentElementManifest,
    ComponentElementProperty
} from "@bizform/type/model/component_element/ComponentElementManifest.model";
import { AccessibilityMenu, ComponentHelper, Debug, ObjectHelper } from "@bizform/helper/dist/js/bizflow/helper.min";
import { ComponentElementClass, ReactComponentElementInit } from "@bizform/core/dist/js/bizflow/core.min";
import { AbstractComponentElement } from "../AbstractComponentElement";
import { I18n } from "../../misc/model/I18n.model";


type Props = SlideMenuProps & {
};

type WrappedCompState = {
    // attribute
    // id?: string;
    model?: MenuItem[];
    // popup?: boolean;
    // style?: object;
    // className?: string;
    easing?: string;
    effectDuration?: number;
    backLabel?: string;
    menuWidth?: number;
    viewportHeight?: number;
    appendTo?: any;

    // event
    onShow?(e: Event): void;
    onHide?(e: Event): void;
};

type State = BaseStateModel & {
    wrappedCompState: WrappedCompState;
};

/**
 * @since 0.0.1
 * @author Byungmin Choi, Hwansoon Park
 * @class
 * @description
 * Slide Menu component element
 */
@ComponentElementClass()
@Static<ComponentElementStatic<string>>()
export class BfSlideMenu extends AbstractComponentElement<Props, State> {
    /* manifest */
    static readonly componentElementManifest: ComponentElementManifest = {
        uniqueId: "_A7WtWP8Mvy2wJZV4GKSvf2dnVL1l7ok",
        category: ComponentCategory.MENU,
        label: I18n.componentElement.slideMenu.label,
        description: I18n.componentElement.slideMenu.description,
        icon: "",
        property: null
    };

    focus(): void {
    }

    setProperty(property: ComponentElementProperty): void {
        try {
            const newState = ComponentHelper.createStateWithProperties<State, null>(
                property,
                this);
            this._newModel = true;
            this.setState(newState);
        } catch (e) {
            Debug.console.error("setProperty", e);
        }
    }

    private _itemValueEvent(e: {originalEvent: Event, item: MenuItem}): void {
        /*
         * 주의:
         * itemValue 는 MenuItem 에 정의된 값이 프로퍼티가 아니다.
         * property panel 에서 form state 변경을 위해 itemValue 를 컴포넌트에 설정하고
         * command 함수(메뉴 클릭)가 호출될 때 이 itemValue 를 전달하기 위해
         * MenuItem 객체에 강제로 주입된 속성이다.
         */
        const itemValue = e.item && (e.item as {itemValue}).itemValue;
        if (itemValue) {
            this.emitFormState(itemValue);
        }
    }

    emitFormState(value: string): void {
    }

    noDisplayInheritance() {
    }

    @ReactComponentElementInit(BfSlideMenu)
    static init(): ComponentElement<string> {
        return;
    }

    initDone(): void {
    }

    destroy(): void {
        this.destroyDone();
    }

    destroyDone(): void {
    }

    /* for React */
    props: Props;
    state: State;

    private _newModel: boolean;
    private _menu: any;

    constructor(props?: Props) {
        super(props);

        this.state = {
            show: false,
            displayMode: ComponentElementDisplayMode.INIT,
            wrappedCompState: {
                model: props.model
            }
        };

        this._setRef = this._setRef.bind(this);
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        this._newModel = false;
        if (this._menu) {
            if (this._menu.container) {
                this._menu.container.style.width = this.state.wrappedCompState.menuWidth + "px";
                this._menu.container.className = "p-slidemenu p-component";
                this._menu.container.className = this._menu.container.className + " " + this.state.wrappedCompState["className"];
            }
        }
    }

    shouldComponentUpdate(nextProps: Readonly<Props>, nextState: Readonly<State>, nextContext: any): boolean {
        return ObjectHelper.hasDifference(nextState, this.state);
     }

    componentWillUnmount(): void {
        this._menu = null;
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        Debug.console.error(error, errorInfo);
    }

    render(): React.ReactNode {
        if (!this.state.show) {
            return null;
        } else {
            return this._render4Edit();
        }
    }

    private _render4Edit(): React.ReactNode {
        const w = this.state.wrappedCompState;
        if (this.accessibility) {
            return (
                <AccessibilityMenu
                    {...w}
                    id={this.elementId}
                    key={this.elementId}
                    newModel={this._newModel}
                    ref={this._setRef}
                />
            );
        } else {
            return (
                <SlideMenu
                    {...w}
                    key={this.elementId}
                    id={this.elementId}
                    popup={false}
                    ref={this._setRef}
                />
            );
        }
    }

    private _setRef(ref): void {
        if (ref) {
            this._menu = ref;
            this.readyComponent();
        }
    }
}
